<template>
  <div class="menu" :class="{collapse:$store.state.app.menuCollapse}" >
    <div class="menu-header" @click="$store.commit('save',['app.menuCollapse',!$store.state.app.menuCollapse])">
      <span class="collapse"><i class="fa fa-th-large"></i></span>
      <span><i class="fa fa-bars"></i>功能菜单</span>
    </div>
    <el-menu default-active="2" router  :collapse="$store.state.app.menuCollapse">
      <!-- <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-setting"></i><span>系统管理</span>
        </template>
        <el-menu-item index="/system/user" >用户管理</el-menu-item>
        <el-menu-item index="/system/org" >组织机构管理</el-menu-item>
        <el-menu-item index="/about">选项1</el-menu-item>
        <el-menu-item index="/about2">选项2</el-menu-item>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-location"></i><span>导航二</span>
        </template>
        <el-menu-item index="/system/user" v-for="item in 20" :key="item">选项{{item}}</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <i class="fa fa-bar-chart"></i><span>导航二</span>
        </template>
        <el-menu-item index="/system/org" v-for="item in 20" :key="item">选项{{item}}</el-menu-item>
      </el-submenu> -->

      <!-- 静态菜单，不参与权限控制 src\router\index.js 中 不设置hidden:true 或  permission: true 就可以显示-->
      <!-- <menu-item :menu="$router.options.routes" /> -->
      <!-- 动态菜单 -->
      <menu-item :menu="$store.state.user.menu" />
    </el-menu>
  </div>

</template>
<script>
import MenuItem from './menuItem'
export default {
  components: { MenuItem },
  
}
</script>
<style>
.menu {
  border: 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.menu .el-menu {
  flex: 1;
  height: 100%;
  overflow-y: auto;
}
.el-menu--vertical{
    overflow-y: auto;
    max-height: 100%;
}
.menu:not(.collapse) {
  width: 230px;
}
.menu .menu-header {
  display: flex;
  align-items: center;
  font-size: 16px;
  width: 100%;
  height: 40px;
  padding: 0px 10px;
  box-sizing: border-box;
  border-right: 1px solid #e6e6e6;
  box-shadow: -2px 3px 10px #ececec;
  position: relative;
  padding-left: 26px;
  cursor: pointer;
  z-index: 1;
  user-select: none;
}

.menu i {
  margin-right: 5px;
}
.el-menu i{
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 16px;
}
.el-menu i>svg{
  width: inherit !important;
  margin-left: 2px;
}
.menu.collapse .el-menu-item span, 
.menu.collapse .el-submenu > .el-submenu__title span,
.menu.collapse .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
}
.menu .menu-header span.collapse {
  display: none;
}
.menu.collapse  .menu-header{
  padding-left: 25px;
}
.menu.collapse .menu-header{
  width: 65px;
}
.menu.collapse  .menu-header span.collapse {
  display: block;
}
.menu.collapse  .menu-header span:not(.collapse) {
  display: none;
}
</style>